import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpBaseService {
  private readonly http = inject(HttpClient);

  /** Un arreglo se envía como parámetro repetido (?a=1&a=2). */
  get<T>(
    endpoint: string,
    params?: Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>,
  ): Observable<T> {
    return this.http.get<T>(endpoint, { params });
  }

  post<T>(endpoint: string, payload: unknown): Observable<T> {
    return this.http.post<T>(endpoint, payload);
  }

  postFormData<T>(endpoint: string, formData: FormData): Observable<T> {
    return this.http.post<T>(endpoint, formData);
  }

  put<T>(endpoint: string, payload: unknown): Observable<T> {
    return this.http.put<T>(endpoint, payload);
  }

  patch<T>(endpoint: string, payload: unknown): Observable<T> {
    return this.http.patch<T>(endpoint, payload);
  }

  patchFormData<T>(endpoint: string, formData: FormData): Observable<T> {
    return this.http.patch<T>(endpoint, formData);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(endpoint);
  }

  deleteEmpty(endpoint: string): Observable<void> {
    return this.http.delete(endpoint, { responseType: 'text' }).pipe(map(() => undefined));
  }
}
